var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgClick(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.666 18.5a.59.59 0 01-.564-.42L5.57 6.302a.589.589 0 01.733-.733L18.08 9.102a.59.59 0 01.158 1.054l-2.936 1.957 3.025 3.026c.23.23.23.603 0 .832l-2.355 2.356a.588.588 0 01-.833 0l-3.025-3.025-1.957 2.935a.59.59 0 01-.49.263zm2.356-4.711c.155 0 .305.061.416.172l3.117 3.117 1.523-1.523-3.117-3.117a.589.589 0 01.09-.906l2.492-1.661-9.531-2.86 2.86 9.531 1.66-2.491a.588.588 0 01.49-.262zM4.194 4.194a.588.588 0 000-.833L3.016 2.184a.588.588 0 10-.832.832L3.36 4.194a.587.587 0 00.833 0zm-.416 1.94a.589.589 0 00-.59-.59H1.423a.589.589 0 000 1.178H3.19a.589.589 0 00.589-.589zm-.762 3.949l1.178-1.178a.588.588 0 10-.833-.833L2.184 9.25a.588.588 0 10.832.833zm5.889-5.889l1.178-1.178a.588.588 0 10-.833-.832L8.072 3.36a.588.588 0 10.833.833zM6.722 3.189V1.422a.589.589 0 00-1.178 0V3.19a.589.589 0 001.178 0z",
    fill: "#722ED1"
  })));
}

export default __webpack_public_path__ + "./fonts/click.d8c7f890d42336a4e31116703c59fea2.svg";
export { SvgClick as ReactComponent };